import React from 'react';

import InfoIcon from '@mui/icons-material/Info';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { useInterval } from '@tzmedical/react-hooks';

import axios from '../../axiosClient.js';
import Alert from '../common/Alert.jsx';
import PageLoading from '../common/PageLoading.jsx';
import YearOverYearHeader from '../YearOverYearHeader.jsx';
import CommGrossYearOverYearRow from './CommGrossYearOverYearRow.jsx';
const REFRESH_INTERVAL_MS = 300000;
function CommGrossYearOverYearTable({ selectedRep, selectedYear }) {
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const fetchRows = React.useCallback(async () => {
    try {
      const { data } = await axios.get(
        `/api/commgross/year-over-year/${encodeURIComponent(selectedRep)}/${selectedYear}`
      );
      setRows(data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setLoading(false);
  }, [selectedRep, selectedYear]);
  React.useEffect(() => {
    setLoading(true);
    setError(null);
    setRows([]);
  }, [selectedRep, selectedYear]);
  useInterval(fetchRows, REFRESH_INTERVAL_MS, loading && !error);
  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        <Tooltip title="Shows YTD Gross Sales for the selected year in the territory assigned to this sales representative.">
          <span>
            YTD Gross Sales by Territory <InfoIcon sx={{ fontSize: 'small' }} />
          </span>
        </Tooltip>
      </Typography>
      <Alert message={error} setMessage={setError} level="error" />
      {loading ? (
        <PageLoading />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <YearOverYearHeader selectedYear={selectedYear} />
            </TableHead>
            <TableBody>
              {rows.map((item) => (
                <CommGrossYearOverYearRow key={item.ProductGroup} item={item} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
export default React.memo(CommGrossYearOverYearTable);
